import { render, staticRenderFns } from "./AssetThread.vue?vue&type=template&id=2c583648&scoped=true"
import script from "./AssetThread.vue?vue&type=script&lang=js"
export * from "./AssetThread.vue?vue&type=script&lang=js"
import style0 from "./AssetThread.vue?vue&type=style&index=0&id=2c583648&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c583648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c583648')) {
      api.createRecord('2c583648', component.options)
    } else {
      api.reload('2c583648', component.options)
    }
    module.hot.accept("./AssetThread.vue?vue&type=template&id=2c583648&scoped=true", function () {
      api.rerender('2c583648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/AssetThread.vue"
export default component.exports